import { history } from '../functions/history';
import notification from './notifications-service';
import logger from './logger-service';

export default {
  notification,
  history,
  logger,
};
